import type { CSSProperties, ReactNode } from 'react'
import { cn } from '@axilon-apps/libs-ui-shadcn'

import './pid.css'

export interface PidBaseProps {
  className?: string
  style?: CSSProperties
  tag?: string
  title?: string
}

/** Classnames helper (same as `cn`). */
export function cx(...parts: Array<string | false | null | undefined>) {
  return cn(...parts)
}

/** Shared label under a glyph. */
export function TagLabel({ children }: { children?: ReactNode }) {
  if (!children) return null
  return <div className="pid-tag">{children}</div>
}
